import { DataGridDecorator } from "./dataGridDecorator";
import { ListDecorator } from "./listDecorator";
import { CustomModalDecorator } from "./customModalDecorator";
import { ComFormDecorator } from "./comFormDecorator";
import { JsonEditDecorator } from "./jsonEditDecorator";
import { IDecorator } from "../types";
import filterTool from "../util/filterTool";
import { Decorator } from "./decorator";
import { FormDecorator } from "./formDecorator";

const decorators: {
    [propName: string]: IDecorator;
} = {};

registerDecorator(DataGridDecorator.NAME, new DataGridDecorator())
registerDecorator(ListDecorator.NAME, new ListDecorator())
registerDecorator(CustomModalDecorator.NAME, new CustomModalDecorator())
registerDecorator(ComFormDecorator.NAME, new ComFormDecorator())
registerDecorator(JsonEditDecorator.NAME, new JsonEditDecorator())
registerDecorator(FormDecorator.NAME, new FormDecorator())

export function registerDecorator(name: string, decorator: IDecorator) {
    decorators[name] = decorator;
}

export function getDecorator(name): IDecorator {
    const decorator = decorators[name];
    if (filterTool.isNull(decorator)) {
        return new Decorator();
    }

    return decorator.getInstance();
}